export default __webpack_public_path__ + "static/media/card-image.dc03ad9b.png";